import apiFM from '../apiFM';
import { showWarning } from '~/components/Notification/Notification.component';

const paiBaseService = '/filemanager/pai';
const MENSAGEM_POPUP_BLOQUEADO =
  'O navegador bloqueou a abertura do arquivo em nova aba. Permita pop-ups para este site e tente novamente. O arquivo será baixado nesta página.';

async function lerRespostaComProgresso(response, onProgress) {
  const totalHeader = response.headers.get('content-length');
  const total = totalHeader ? Number(totalHeader) : 0;

  if (onProgress) {
    onProgress({ received: 0, total });
  }

  if (!response.body || typeof response.body.getReader !== 'function') {
    return response.blob();
  }

  const reader = response.body.getReader();
  const chunks = [];
  let received = 0;
  let concluido = false;

  /* eslint-disable no-await-in-loop */
  while (!concluido) {
    const passo = await reader.read();
    if (passo.done) {
      concluido = true;
    } else {
      chunks.push(passo.value);
      received += passo.value.length;

      if (onProgress) {
        onProgress({ received, total });
      }
    }
  }
  /* eslint-enable no-await-in-loop */

  return new Blob(chunks, {
    type: response.headers.get('content-type') || 'application/pdf',
  });
}

export async function fileManagerPaiDownload(fileName, opcoes) {
  const url = `${apiFM.defaults.baseURL}${paiBaseService}/download?nomeArquivo=${fileName}`;
  if (fileName && fileName.toLowerCase().endsWith('.pdf')) {
    const urlPdf = `${url}&isInlineContent=true`;
    const signal = opcoes && opcoes.signal;
    const onProgress = opcoes && opcoes.onProgress;
    const onPopupBloqueado = opcoes && opcoes.onPopupBloqueado;
    const janela = abrirJanelaPreparada();

    try {
      const response = await fetch(urlPdf, signal ? { signal } : undefined);
      if (!response.ok) {
        throw new Error('Falha ao baixar arquivo');
      }
      const blob = await lerRespostaComProgresso(response, onProgress);
      const blobUrl = URL.createObjectURL(blob);
      abrirBlobNaJanela(blobUrl, janela, fileName, onPopupBloqueado);
    } catch (erro) {
      fecharJanela(janela);
      throw erro;
    }
  } else {
    window.location.assign(url);
  }
}

export function getFullUrl(nomeArquivo) {
  return `${apiFM.defaults.baseURL}${paiBaseService}/download?nomeArquivo=${nomeArquivo}`;
}

function popupFoiBloqueado(janela) {
  return !janela || janela.closed;
}

function abrirJanelaPreparada() {
  const janela = window.open('about:blank', '_blank');
  if (popupFoiBloqueado(janela)) {
    return null;
  }

  try {
    janela.document.title = 'Carregando arquivo…';
    janela.document.body.innerHTML =
      '<p style="font-family:sans-serif;padding:24px">Carregando arquivo…</p>';
  } catch {
    return janela;
  }

  return janela;
}

function fecharJanela(janela) {
  if (popupFoiBloqueado(janela)) {
    return;
  }

  janela.close();
}

function obterNomeArquivo(fileName) {
  if (!fileName) {
    return 'arquivo.pdf';
  }

  const partes = String(fileName).split('/');
  return partes[partes.length - 1] || 'arquivo.pdf';
}

function dispararDownloadArquivo(blobUrl, fileName) {
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = obterNomeArquivo(fileName);
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function avisarPopupBloqueado(onPopupBloqueado) {
  if (typeof onPopupBloqueado === 'function') {
    onPopupBloqueado();
    return;
  }

  showWarning(MENSAGEM_POPUP_BLOQUEADO);
}

function abrirBlobNaJanela(blobUrl, janela, fileName, onPopupBloqueado) {
  if (!popupFoiBloqueado(janela)) {
    janela.location.href = blobUrl;
    return;
  }

  const novaJanela = window.open(blobUrl, '_blank');
  if (!popupFoiBloqueado(novaJanela)) {
    return;
  }

  avisarPopupBloqueado(onPopupBloqueado);
  dispararDownloadArquivo(blobUrl, fileName);
}
